import { IconActivity, IconGlobe, IconHelpCircle, IconInfo, IconMessageSquare } from 'featherico';
import { Dropdown, OptionLink, OptionWithModal, createLinkOption } from '../../../../components/Dropdown';
import { useAppContext } from '../../../../hooks/useAppContext';
import { isAnyAdmin } from '../../../../services/User';
import { JustLaunchedMenuItems } from '../../../JustLaunched/MenuItems';
import IntercomSupportLink from '../../../Navigation/SupportLink/IntercomSupportLink';
import { HrListSupport } from '../../../Navigation/SupportLink/WithHrListSupportModal';

const OptionHelpLink = createLinkOption((props: { onClick?: () => void }) => <IntercomSupportLink {...props} />);

export default function HelpMenu() {
    const { user: currentUser } = useAppContext();

    return (
        <Dropdown
            kind="PLAIN"
            showChevron={false}
            ariaLabel={`Help menu`}
            label={
                <>
                    <IconHelpCircle />
                </>
            }
            eventTracking={{ category: 'navigation header help', action: 'toggle' }}
            large={true}
            className="top-aligned left-aligned"
        >
            <OptionLink
                href="https://intercomdocs.small-improvements.com/en/"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'help center' }}
            >
                <IconInfo /> Help Center
            </OptionLink>
            {isAnyAdmin(currentUser) ? (
                <OptionHelpLink />
            ) : (
                <OptionWithModal
                    modalProps={{
                        size: 'LG_WIDTH',
                        title: 'Get Support',
                        body: () => <HrListSupport />,
                    }}
                    eventTracking={{
                        category: 'navigation header help',
                        action: 'click',
                        label: 'get help non-admin',
                    }}
                >
                    <IconMessageSquare /> Get Support
                </OptionWithModal>
            )}
            <OptionLink
                href="https://status.small-improvements.com"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'system status' }}
            >
                <IconActivity /> System Status
            </OptionLink>
            <OptionLink
                href="https://small-improvements.com"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'si home page' }}
            >
                <IconGlobe /> Website
            </OptionLink>
            <JustLaunchedMenuItems />
        </Dropdown>
    );
}
